export interface DataPage<DataType> {
  data: DataType[];
}

export function objectToQueryString(input: Record<string, string | string[]> | undefined): string {
  if (!input) {
    return "";
  }

  return Object.entries(input)
    .map(([key, val]) => {
      const encodedValue = Array.isArray(val) ? val.map(encodeURIComponent).join(",") : encodeURIComponent(val);
      return `${encodeURIComponent(key)}=${encodedValue}`;
    })
    .join("&");
}
